import { createAction, props } from '@ngrx/store';

export const setTotal = createAction(
    '[Simyo Component] Total shopping-cart', 
    props<{total: number}>()
);